<script setup>
import RoadCanvas from './RoadCanvas.vue';
import MarqueeText from './MarqueeText.vue';
import { LOBBY_PHASE } from '../domain/lobbyPhase.js';

const props = defineProps({ snapshot: { type: Object, required: true }, t: { type: Function, required: true }, notice: String });
const emit = defineEmits(['table', 'logout', 'action']);

function phaseText(table) {
  if (table.phase === LOBBY_PHASE.MAINTENANCE) return props.t('vueDesktop.status.tableMaintenance', 'Maintenance');
  if (table.phase === LOBBY_PHASE.SHUFFLING) return props.t('vueDesktop.status.tableShuffling', 'Shuffling');
  if (table.phase === LOBBY_PHASE.CLOSED) return props.t('status.bettingStopped', 'Betting closed');
  return props.t('status.bettingOpen', 'Betting');
}
</script>

<template>
  <section class="hall-screen is-tiled vue-hall-screen" aria-hidden="false">
    <header class="hall-header">
      <div class="hall-brand-patch"><img src="/assets/brand/wanli-script-gold-v1.webp" alt="Wanli" /></div>
      <MarqueeText class="hall-news" :label="t('vueDesktop.label.notice', 'Notice')" :text="snapshot.news" />
      <nav class="hall-header-actions" :aria-label="t('vueDesktop.label.tableInfo', 'Lobby actions')">
        <button type="button" @click="emit('action', 'records')"><i class="hall-action-icon record" aria-hidden="true" /><span>{{ t('buttonCompact.betRecord', 'Record') }}</span></button>
        <button type="button" @click="emit('action', 'password')"><i class="hall-action-icon key" aria-hidden="true" /><span>{{ t('buttonCompact.changePassword', 'Password') }}</span></button>
        <button class="hall-exit" type="button" @click="emit('logout')"><i class="hall-action-icon exit" aria-hidden="true" /><span>{{ t('button.exitGame', '退出') }}</span></button>
      </nav>
    </header>
    <main class="hall-list" :aria-label="t('vueDesktop.label.tableInfo', 'VIP table list')">
      <div class="hall-carousel">
        <div class="hall-tile-grid" :aria-label="t('vueDesktop.label.tableInfo', 'VIP tables')">
          <article
            v-for="table in snapshot.tables"
            :key="table.id"
            class="hall-tile-card"
            role="button"
            tabindex="0"
            :aria-label="`${t('button.selectTable', 'Select table')} ${table.displayName}`"
            @click="emit('table', table.index)"
            @keydown.enter="emit('table', table.index)"
            @keydown.space.prevent="emit('table', table.index)"
          >
            <header class="hall-tile-head">
              <strong class="hall-tile-title"><small>{{ t('vueDesktop.label.tableInfo', 'Live Table') }}</small><span>{{ table.displayName }}</span></strong>
              <div class="hall-tile-stats">
                <span class="b"><em>{{ t('vueDesktop.baccarat.banker', 'Banker') }}</em><b>{{ table.banker }}</b></span>
                <span class="p"><em>{{ t('vueDesktop.baccarat.player', 'Player') }}</em><b>{{ table.player }}</b></span>
                <span class="t"><em>{{ t('vueDesktop.baccarat.tie', 'Tie') }}</em><b>{{ table.tie }}</b></span>
              </div>
              <span class="hall-tile-time" :class="{ maintenance: !table.lobbyBettingOpen }">
                <template v-if="table.lobbyBettingOpen"><b>{{ table.countdown }}</b><small>SEC</small></template>
                <template v-else><b>--</b><small>{{ phaseText(table) }}</small></template>
              </span>
            </header>
            <div class="hall-tile-road-wrap"><RoadCanvas :analysis="table.analysis" :seed="table.index + 1" /></div>
            <footer class="hall-tile-foot"><span class="hall-table-status" :class="{ 'is-open':table.lobbyBettingOpen }">{{ phaseText(table) }}</span><span class="hall-select-label">{{ t('button.selectTable', 'Select table') }}</span></footer>
          </article>
        </div>
        <div v-if="notice" class="hall-enter-toast show" role="status">{{ notice }}</div>
      </div>
    </main>
  </section>
</template>
